import { Box, Stack, Typography, styled } from '@mui/material';
export var StyledChartContainer = styled(Box)(function (_a) {
  var theme = _a.theme;
  return {
    position: 'relative',
    backgroundColor: theme.palette.common.white,
    border: "1px solid ".concat(theme.palette.divider),
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3)
  };
});
export var StyledHeaderRow = styled(Stack)({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '1rem',
  margin: '1rem'
});
export var StyledTitleChart = styled(Typography)(function (_a) {
  var theme = _a.theme;
  return {
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(18)
  };
});
export var StyledLegendContainer = styled(Stack)(function (_a) {
  var theme = _a.theme;
  return {
    flexDirection: 'row',
    gap: theme.spacing(4),
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    paddingTop: theme.spacing(2)
  };
});
export var StyledLegendLabel = styled(Stack)(function (_a) {
  var theme = _a.theme;
  return {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2)
  };
});
export var StyledLegendLine = styled(Box)({
  width: '1.9375rem',
  flexShrink: 0
});
export var DISABLED_LEGEND_COLOR = '#7F7F7F';